import "core-js/modules/es.array.join";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.split";
import logger from '../../../../lib/logger/logger';
var spanishAmericanTZs = {
  'PST': 'hora Pacífico',
  'PDT': 'hora Pacífico',
  'MST': 'hora montaña',
  'MDT': 'hora montaña',
  'CST': 'hora central',
  'CDT': 'hora central',
  'EST': 'hora este',
  'EDT': 'hora este'
};

var getTimezone = function getTimezone(_ref) {
  var date = _ref.date,
      timeZone = _ref.timeZone,
      language = _ref.language,
      _ref$timeZoneName = _ref.timeZoneName,
      timeZoneName = _ref$timeZoneName === void 0 ? 'short' : _ref$timeZoneName;
  var timeZoneAbbreviation = '';

  try {
    var localeString = date.toLocaleTimeString('en-us', {
      timeZone: timeZone,
      timeZoneName: timeZoneName
    });
    timeZoneAbbreviation = 'short' === timeZoneName ? localeString.split([' '])[2] : localeString.split([' ']).slice(2, 8).join(' '); // Workaround for IE

    if (typeof timeZoneAbbreviation === 'undefined' || timeZoneAbbreviation === '' || /GMT/.test(timeZoneAbbreviation.toString())) {
      timeZoneAbbreviation = date.toTimeString().match(new RegExp('[A-Z](?!.*[(])', 'g'));
      timeZoneAbbreviation = timeZoneAbbreviation === null || typeof timeZoneAbbreviation === 'undefined' ? '' : timeZoneAbbreviation.join('');
    }
  } catch (error) {
    logger.error('getTimezone', error);
    return undefined;
  }

  if (language === 'sp' && timeZoneAbbreviation in spanishAmericanTZs) {
    timeZoneAbbreviation = spanishAmericanTZs[timeZoneAbbreviation];
  }

  return timeZoneAbbreviation;
};

export default getTimezone;